import React from 'react';
import language from '@language';
import './style.scss';

export default class Success extends React.Component<any> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <div className="redirect-to-page">
          <p>{language.will_redirect}</p>
          <div
            className="overlay"
            style={{ backgroundColor: 'transparent', top: '75px' }}
          >
            <div className="loader" />
          </div>
        </div>
      </div>
    );
  }
}
